import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { BaseOfferFields } from '@innogy/become-a-customer/shared/interfaces';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { TypedComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wl-offer-more-info-block[rendering][offer]',
  templateUrl: './offer-more-info-block.component.html',
  imports: [CommonModule],
  standalone: true,
})
export class OfferMoreInfoBlockComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: TypedComponentRendering<BaseOfferFields>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer!: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() moreInfoButtonClick?: (offer: Offer) => unknown;

  moreInfoBlock: any = {};

  ngOnInit(): void {
    this.moreInfoBlock.title = this.rendering.fields.moreInfoTitle;
    this.moreInfoBlock.message = this.rendering.fields.moreInfoMessage;
    this.moreInfoBlock.buttonText = getFieldValue(
      this.rendering,
      'moreInfoButtonText',
      undefined
    );
  }
}
